import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetSalesCustomerList($input: BillingLocationListInput!) {
    location {
      listBillingLocations(input: $input) {
        __typename
        ... on BillingLocationListSuccess {
          billingLocations {
            companyLocationAssociationId
            company {
              companyId
              name
            }
            billingLocation {
              locationId
              name
              address1
              address2
              city
              postalCode
              description
              region {
                shortIsoCode
                isoCode
              }
              country {
                name
              }
            }
            salesPersons {
              salesmanNbr
              name
              initials
            }
          }
        }
        ... on BillingLocationListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
